import {
    GetCreditCardStatementsAccountsResponse,
    fetchGetCreditCardStatementsAccounts
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { useGetCreditCardDashboardData } from '../dashboard/useGetCreditCardDashboardData';

export const useFetchCreditCardStatements =
    (): GetCreditCardStatementsAccountsResponse => {
        const stateKey = useStateKey();
        const { accountId } = useGetCreditCardDashboardData();

        const { data } = useQuery({
            queryKey: ['credit-card-statements', stateKey, accountId],
            queryFn: async () => {
                const responseData = await fetchGetCreditCardStatementsAccounts(
                    {
                        stateKey,
                        accountId
                    }
                );
                return responseData as GetCreditCardStatementsAccountsResponse;
            },
            suspense: true
        });

        return data as GetCreditCardStatementsAccountsResponse;
    };
